import { is } from "date-fns/locale";
import { isNode } from "graphql/language/ast";

export const traverseTreeArray = (treeList, action, parent = null) => {
  console.log("traverseTreeArray called");
  (treeList || []).forEach((item) => {
    try {
      action(item);
      if (item.children && item.children.length !== 0) {
        traverseTreeArray(item.children, action, item);
      }
    } catch (error) {
      console.error("Error in traverseTreeArray:", error);
    }
  });
};


export const removeTreeItem = (treeList, predicate, parent = null) => {
  console.log("removeTreeItem called");
  treeList.forEach((item) => {
    try {
      if (predicate(item)) {
        // This section is error-prone due to potential "undefined" values and mutations
        let index = parent ? parent.children.indexOf(item) : treeList.indexOf(item);
        if (index !== -1) {
          if (parent) {
            parent.children.splice(index, 1);
          } else {
            treeList.splice(index, 1);
          }
        }
      }
      if (item.children && item.children.length !== 0) {
        removeTreeItem(item.children, predicate, item);
      }
    } catch (error) {
      console.error("Error in removeTreeItem:", error);
    }
  });
};

export function findTreeItem(treeList, predicate) {
  console.log("findTreeItem called");
  let selectedItem;
  try {
    for(let i = 0; i < (treeList || []).length; i++) {
      const item = treeList[i];
      if (predicate(item)) {
        return item;
      }   
      if(item.children && item.children.length !== 0) {
        selectedItem = findTreeItem(item.children, predicate);
      }
      if(selectedItem) {
        return selectedItem;
      }
    }
  } catch (error) {
    console.error("Error in findTreeItem:", error);
  }
}

  export function getTreeItemParent(treeList, node) {
    if(!node)
      return;
    let parent;
    for(let i =0; i< (treeList || []).length; i++){
      let item = treeList[i]
      let matchedChild = (item.children || []).find(item => item.id === node.id);
      if(matchedChild){
        return item;
      } 
      if(item.children && item.children.length !==0)
      parent = getTreeItemParent(item.children, node);
  
      if(parent){
        return parent;
      }
    }
}
export function isNodeAncestor(parent, node){
  if(!node){
    return false;
  }
  let isAncestor = false;
  let matchedChild = (parent.children || []).find(item => item.id === node.id);
  if(matchedChild){
    return true;
  }
  for (let index = 0; index < (parent.children|| []).length; index++) {
    let element = parent.children[index];
    isAncestor = isNodeAncestor(element, node);    
  }
  return isAncestor;
}


export function isEditingMode(node){
  return node.children && node.children.some((child)=> child.isEditing || isEditingMode(child) )
}

export function validateFlatList(flat_list) {
  const ids = new Set();
  const treeList = [];
  let unattachedItems = [];

  // Validate each item individually
  for (let item of flat_list) {
    // Check for unique IDs
    if (ids.has(item.id)) {
      console.error("Duplicate ID found:", item.id);
      return false;
    }
    ids.add(item.id);

    // Check for self-referencing paths
    const pathParts = item.path.split('.').filter(Boolean);
    if (pathParts.includes(item.id.toString())) {
      console.error("Self-referencing path for item:", item);
      return false;
    }

    if (item.path === "") {
      treeList.push(item);
    } else {
      unattachedItems.push(item);
    }
  }

  let prevUnattachedCount;
  do {
    prevUnattachedCount = unattachedItems.length;
    unattachedItems = unattachedItems.filter(item => {
      if (!pushTreeItem(treeList, item)) {
        return true; // If not attached, keep the item in the unattached list
      }
      return false; // If attached, remove the item from the unattached list
    });
  } while (unattachedItems.length > 0 && unattachedItems.length < prevUnattachedCount);

  if (unattachedItems.length > 0) {
    console.error("Items that couldn't be attached:", unattachedItems);
    return false;
  }

  return true;
}

export function pushTreeItem(treeList, pushItem) {
  if (!pushItem.path || pushItem.path === "") {
    if (!treeList.some(item => item.id === pushItem.id)) {
      treeList.push(pushItem);
      treeList.sort((a, b) => a.name.localeCompare(b.name)); // Sort treeList after adding item
      return true;
    }
    return false;
  }

  for (let index = 0; index < treeList.length; index++) {
    const item = treeList[index];
    let itemPath = item.path ? `${item.path}.${item.id}` : `${item.id}`;
    if (itemPath === pushItem.path) {
      if (!item.children) {
        item.children = [];
      }

      if (!item.children.some(child => child.id === pushItem.id)) {
        item.children.push(pushItem);
        item.children.sort((a, b) => a.name.localeCompare(b.name)); // Sort children after adding item
        return true;
      }
      return false;
    }

    if (item.children && item.children.length !== 0) {
      if (pushTreeItem(item.children, pushItem)) {
        item.children.sort((a, b) => a.name.localeCompare(b.name)); // Sort children in each recursive call
        return true;
      }
    }
  }
  return false;
}

export function updateTreeItem(treeList, id, itemProps, parent = null) {
  if (!treeList)
    return;

  treeList.forEach((item) => {
    if (item.id === id) {
      Object.assign(item, itemProps);

      if (parent && parent.children) {
        // Sort the parent's children after updating an item
        parent.children.sort((a, b) => a.name.localeCompare(b.name));
      } else {
        // Sort the root level if no parent is present
        treeList.sort((a, b) => a.name.localeCompare(b.name));
      }
      return;
    }
    if (item.children) {
      updateTreeItem(item.children, id, itemProps, item);
    }
  });
}
export function convertListToTree(flatList) {
  console.log("convertListToTree called");

  // Step 1: Group by path length
  const groupedByPathLength = {};
  flatList.forEach(folder => {
      const pathLen = folder.path ? folder.path.split('.').length : 0;
      if (!groupedByPathLength[pathLen]) {
          groupedByPathLength[pathLen] = [];
      }
      groupedByPathLength[pathLen].push(folder);
  });

  // Dictionary to hold all nodes by their ID for quick access
  const nodes = {};
  // Initialize the root
  const roots = [];

  // Step 2: Start with root folders
  (groupedByPathLength[0] || []).forEach(folder => {
      const node = {
          id: folder.id,
          name: folder.name,
          children: [],
          type: folder.type
      };
      nodes[folder.id] = node;
      roots.push(node);
  });

  // Step 3: Proceed level by level
  let pathLen = 1;
  while (groupedByPathLength[pathLen]) {
      groupedByPathLength[pathLen].forEach(folder => {
          const parentID = folder.path.split('.').pop();
          if (nodes[parentID]) {
              const node = {
                  id: folder.id,
                  name: folder.name,
                  children: [],
                  type: folder.type
              };
              nodes[parentID].children.push(node);
              nodes[folder.id] = node;
          }
      });
      pathLen++;
  }
  Object.values(nodes).forEach(node => {
    node.children.sort((a, b) => a.name.localeCompare(b.name));
  });
  roots.sort((a, b) => a.name.localeCompare(b.name));

  return roots;
}

